cb.define([], function() {
  var PC_pc_productlist_filterVM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {
      viewmodel.on('beforeSearch', function(args) {
        let prodcutTags = args.commonVOs.filter(v => v.itemName === "prodcutTag")
        if (prodcutTags.length && prodcutTags[0].value1.length > 1) {
          args.isDistinct = true;
        }
      });
      viewmodel.on('afterInit', (args) => {
        if (viewmodel.get('detail.omsWarehouse')) {
          // 电商仓
          var condition = {
            "isExtend": true,
            simpleVOs: []
          };
          condition.simpleVOs.push({
            field: 'eStore',
            op: 'in',
            value1: 1
          });
          viewmodel.get('detail.omsWarehouse').getFromModel().setFilter(condition);
        }
      })
    }
  }
  try {
    module.exports = PC_pc_productlist_filterVM_Extend;
  } catch (error) {

  }
  return PC_pc_productlist_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/pc_productlist_filterVM.Extend.js